import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { HbaseCopySource } from 'app/model/pipeline/copysource/hbase.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(HbaseCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class HbaseCopySourceAdapter extends CopySourceAdapter<HbaseCopySource, Model.HBaseSource> {
    protected override async _toResource(copySource: HbaseCopySource): Promise<Model.HBaseSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(HbaseCopySource).name);
    }

    protected override async _toModel(
        resource: Model.HBaseSource,
        copyActivity: CopyActivity
    ): Promise<HbaseCopySource> {
        return this._toTabularModel(resource, copyActivity, HbaseCopySource.MODEL);
    }
}
